<template>
  <v-card class="pa-6">
    <v-btn icon color="#dfdfdf" absolute top right @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <div class="d-flex justify-center">
      <h2 class="main-title">Detalhes</h2>
    </div>

    <v-card-text>
      <div class="d-flex align-center">
        <h2 class="secondary-title">Informações pessoais:</h2>
        <div class="divider"></div>
      </div>

      <v-row class="ma-0 py-3">
        <v-col cols="12" sm="4">
          <strong class="label"> Nome completo: </strong>
          <br />
          <span>{{ client.name == null ? "Sem registros" : client.name }}</span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> E-mail: </strong>
          <br />
          <span>{{ client.email ? client.email : "Sem registros"  }}</span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> CPF/CNPJ: </strong>
          <br />
          <span>{{ client.cnpj ? client.cnpj : "Sem registros" }}</span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Data de entrada: </strong>
          <br />
          <span>
            {{ client.created_at == null ? "Sem registros" : formatDate(client.created_at) }}</span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Telefone: </strong>
          <br />
          <span>
            {{ client.phoneNumber ? client.phoneNumber : "Sem registros" }}</span>
        </v-col>
      </v-row>

      <v-row class="ma-0 py-3">
        <v-col cols="12" sm="4">
          <strong class="label"> CEP: </strong>
          <br />
          <span> {{addressSelect ? addressSelect.postalCode : 'Sem registros'}} </span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Endereço: </strong>
          <br />
          <span> {{addressSelect ? addressSelect.addressName : 'Sem registros'}} </span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Número: </strong>
          <br />
          <span> {{addressSelect ? addressSelect.addressNumber : 'Sem registros'}} </span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Bairro: </strong>
          <br />
          <span> {{addressSelect ? addressSelect.neighborhood : 'Sem registros'}} </span>

        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Estado: </strong>
          <br />
          <span> {{addressSelect ? addressSelect.state : 'Sem registros'}} </span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Cidade: </strong>
          <br />
          <span> {{addressSelect ? addressSelect.city : 'Sem registros'}} </span>
        </v-col>

        <v-col cols="12" sm="4">
          <strong class="label"> Referência: </strong>
          <br />
          <span> {{addressSelect ? addressSelect.addressComplement : 'Sem registros'}} </span>
        </v-col>
      </v-row>
    </v-card-text>

    <v-row class="ma-0" justify="center">
      <v-col cols="12" sm="6" class="d-flex justify-center align-center">
        <h2 class="sell">Compras no site: {{client.quantityPurchasesWebsite }}</h2>
      </v-col>
    </v-row>

    <v-row class="ma-0" justify="center">
      <v-col cols="12" sm="6" class="d-flex justify-center align-center">
        <v-btn block class="secondary-button" @click="$emit('close')"
          >Fechar</v-btn
        >
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.divider {
  margin-left: 15px;
  width: 100%;
  border: 0.5px solid #bc0000;
}

.label {
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.15px;
  color: #232021;
}

.label-item {
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.15px;
  color: #232021;
}

.sell {
  font-weight: bold;
  font-size: 24px;
  line-height: 25px;
  letter-spacing: 0.15px;
  color: #bc0000;
}
</style>

<script>
import moment from "moment";

export default {
  name: "Detail",

  props: {
    client: Object,
  },
  mounted() {
  },
  data: () => ({
    address: null
  }),
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY hh:mm");
    },

  },
  computed:{
    addressSelect (){
      return this.client && this.client.userAddress && this.client.userAddress.length > 0 ? this.client.userAddress[0] : null
    }
  }
};
</script>

<style>
</style>
